'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('slick-carousel');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _plyr = require('plyr');

var _plyr2 = _interopRequireDefault(_plyr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jQueryBridget = require('jquery-bridget');

var players = Array.from(document.querySelectorAll('.video-section .plyr__video-embed')).map(function (p) {
  return new _plyr2.default(p, {
    controls: ['play-large', 'play', 'progress', 'mute', 'volume']
  });
});

var Flickity = require('flickity');
require('flickity-as-nav-for');
require('flickity-imagesloaded');

function isAnyPartOfElementInViewport(el) {

  var rect = el.getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth;

  var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
  var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

  return vertInView && horInView;
}

(0, _jquery2.default)(document).ready(function () {

  function stickyCartButton() {

    var productForm = document.querySelector('.product-form-wrap');
    if (productForm !== null) {
      (0, _jquery2.default)('body').addClass('fixed-cart-button');

      window.addEventListener('scroll', function (e) {
        if (isAnyPartOfElementInViewport(productForm)) {
          /* Pass element id/class you want to check */
          (0, _jquery2.default)('body').removeClass('fixed-cart-button');
        } else {
          (0, _jquery2.default)('body').addClass('fixed-cart-button');
        }
      });
    }
  }

  function mediaqueryresponse(mql) {
    if (mql.matches) {
      // Mobile JS
      stickyCartButton();
    } else {}
  }

  var mql = window.matchMedia("only screen and (max-width: 47em)");
  mediaqueryresponse(mql); // call listener function explicitly at run time
  mql.addListener(mediaqueryresponse); // attach listener function to listen in on state changes


  var options = {

    pageDots: false,
    adaptiveHeight: true,
    prevNextButtons: false
    //imagesLoaded: true

  };

  if (matchMedia('only screen and (max-width: 47em)').matches) {
    options.imagesLoaded = true;
  }

  var productImage = document.querySelector('.main-product-image');
  if (productImage) {
    var flkty = new Flickity('.main-product-image', options);
  }

  var carouselNav = document.querySelector('.carousel-nav');
  if (carouselNav) {
    var flkty2 = new Flickity('.carousel-nav', {
      asNavFor: '.main-product-image',
      contain: true,
      pageDots: false,
      cellAlign: 'center',
      prevNextButtons: false
      //imagesLoaded: true

    });
  }
});

(0, _jquery2.default)(window).scroll(function () {
  if ((0, _jquery2.default)(window).scrollTop() >= 48) {
    (0, _jquery2.default)('.algemene-header ').addClass('fixed-header');
    var height = (0, _jquery2.default)('.algemene-header').outerHeight();
    (0, _jquery2.default)('.algemene-header + div').css('height', height);
  } else {
    (0, _jquery2.default)('.algemene-header ').removeClass('fixed-header');
    (0, _jquery2.default)('.algemene-header + div').css('height', '0px');
  }
});

var collectionFilter = document.getElementById('collectionFilter') || false;
if (collectionFilter) {
  collectionFilter.addEventListener('change', function () {
    document.location.href = '?sort_by=' + this.options[this.selectedIndex].value;
  });
}

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

(0, _jquery2.default)(document).ready(function () {

  (0, _jquery2.default)('body').on('click', '.countries-expand-button', function (e) {
    e.preventDefault();
    (0, _jquery2.default)(this).parent().find('.countries-expand-links').toggleClass('active');
  });

  (0, _jquery2.default)('body').on('click', '.FaqSummary a, .faq-summary-mobile a', function () {
    var expand = (0, _jquery2.default)(this).attr('data-expand');
    (0, _jquery2.default)('section.faq-section').removeClass('is-active');
    (0, _jquery2.default)('section.faq-section[data-expand="' + expand + '"]').addClass('is-active');
    (0, _jquery2.default)('.FaqSummary div, .faq-summary-mobile').removeClass('is-active');
    (0, _jquery2.default)(this).closest('div').addClass('is-active');
  });

  (0, _jquery2.default)('body').on('click', '.filter-expand-button, .filter-close, .filter-bg', function (e) {
    e.preventDefault();
    (0, _jquery2.default)('.filter').toggleClass('active');
  });

  (0, _jquery2.default)('body').on('click', '.Faq__ItemWrapper strong', function (e) {
    e.preventDefault();
    if ((0, _jquery2.default)(this).parent().hasClass('active')) {
      (0, _jquery2.default)(this).parent().removeClass('active');
    } else {
      (0, _jquery2.default)('.Faq__ItemWrapper').removeClass('active');
      (0, _jquery2.default)(this).parent().addClass('active');
    }
  });

  (0, _jquery2.default)(".shopify-product-form .quantity button").on("click", function (e) {
    e.preventDefault();

    var $button = (0, _jquery2.default)(this);
    var oldValue = $button.parent().find("input").val();

    if ($button.text() == "+") {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      if (oldValue > 1) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }

    $button.parent().find("input").val(newVal).trigger('change');
  });

  function alternatingUSPs() {
    var $els = (0, _jquery2.default)('.announcement-bar .usps li'),
        i = 0,
        len = $els.length;

    $els.slice(1).hide();
    var alternating = setInterval(function () {
      $els.eq(i).fadeOut(function () {
        i = (i + 1) % len;
        $els.eq(i).fadeIn();
      });
    }, 3500);
  };

  function toggleSubMenuFooter() {
    (0, _jquery2.default)('body').on('click', '.biglist a.with-subs', function (e) {
      e.preventDefault();
      (0, _jquery2.default)(this).next('ul').toggle();
    });
  }

  function mediaqueryresponse(mql) {
    if (mql.matches) {
      // Mobile JS
      alternatingUSPs();
      toggleSubMenuFooter();
      (0, _jquery2.default)('.faq-summary-mobile.is-active').removeClass('is-active');
      (0, _jquery2.default)('.Faq section.is-active').removeClass('is-active');
    } else {}
  }

  var mql = window.matchMedia("only screen and (max-width: 47em)");
  mediaqueryresponse(mql); // call listener function explicitly at run time
  mql.addListener(mediaqueryresponse); // attach listener function to listen in on state changes


  (0, _jquery2.default)(".main-nav li.expand").hover(function () {
    (0, _jquery2.default)('.nav-hover').addClass('active');
  }, function () {
    (0, _jquery2.default)('.nav-hover').removeClass('active');
  });

  //var tabTitle = '<ul class="tabs">';
  (0, _jquery2.default)('.prod_description > div.tab-content').each(function (i, item) {
    if (i > 0) {
      (0, _jquery2.default)(this).removeClass('active');
    }
    (0, _jquery2.default)(this).attr('id', "tabs-" + i);
    var titletext = (0, _jquery2.default)(this).find('h2').text();
    var title = (0, _jquery2.default)(this).find('h2');
    title.append('<svg width="12" height="7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l5 5 5-5" stroke="#000"/></svg>');
    (0, _jquery2.default)(this).children().not(':first-child').wrapAll('<div class="tab-expand" />');
    if (i > 0) {
      var titlelist = '<li><button data-tab="tabs-' + i + '">' + titletext + '</button></li>';
    } else {
      var titlelist = '<li class="active"><button data-tab="tabs-' + i + '">' + titletext + '</button></li>';
    }
  });

  (0, _jquery2.default)('.spacer').remove();
  (0, _jquery2.default)('body').on('click', '.tab-content h2', function (e) {
    e.preventDefault();
    if ((0, _jquery2.default)(this).parent().hasClass('active')) {
      (0, _jquery2.default)(this).parent().removeClass('active');
      (0, _jquery2.default)(this).parent().find('.tab-expand').slideUp();
    } else {
      (0, _jquery2.default)('.tab-content').removeClass('active');
      (0, _jquery2.default)('.tab-expand').slideUp();
      (0, _jquery2.default)(this).parent().find('.tab-expand').slideDown();
      (0, _jquery2.default)(this).parent().addClass('active');
      // $(this)[0].scrollIntoView({block: 'center'});
    }
  });

  (0, _jquery2.default)("form.cart input").on('change keyup paste', function () {
    (0, _jquery2.default)('input[name="update"]').click();
  });

  (0, _jquery2.default)('body').on('click', '.menu-toggle', function () {
    (0, _jquery2.default)(this).addClass('active');
    (0, _jquery2.default)('body').css('overflow', 'hidden');
    (0, _jquery2.default)('.main-nav').addClass('active');
  });

  (0, _jquery2.default)('body').on('click', '.menu-close', function () {
    (0, _jquery2.default)('.menu-toggle').removeClass('active');
    (0, _jquery2.default)('body').css('overflow', 'auto');
    (0, _jquery2.default)('.main-nav').removeClass('active');
  });

  (0, _jquery2.default)('body').on('click', '.main-nav.active + .nav-hover', function () {
    (0, _jquery2.default)('.menu-toggle').removeClass('active');
    (0, _jquery2.default)('body').css('overflow', 'auto');
    (0, _jquery2.default)('.main-nav').removeClass('active');
  });

  (0, _jquery2.default)('body').on('click', '.main-nav.active li.expand > a', function (e) {
    e.preventDefault();

    if ((0, _jquery2.default)(this).parent().hasClass('active')) {
      (0, _jquery2.default)('.main-nav.active li.expand').removeClass('active');
      (0, _jquery2.default)(this).parent().removeClass('active');
    } else {
      (0, _jquery2.default)('.main-nav.active li.expand').removeClass('active');
      (0, _jquery2.default)(this).parent().addClass('active');
    }
  });
});

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(".hamburger").click(function () {
    (0, _jquery2.default)(this).toggleClass("is-active");
    (0, _jquery2.default)('body').toggleClass("is-active");
    (0, _jquery2.default)('html').toggleClass("is-active");
    (0, _jquery2.default)('.nav__menu').toggleClass("is-active");
    (0, _jquery2.default)('.nav__searchright-item--select').toggleClass("is-active");
  });

  (0, _jquery2.default)(".product-detail__info-item-title").click(function () {
    var Parent = (0, _jquery2.default)(this).parent();
    if (Parent.hasClass("is-open")) {
      (0, _jquery2.default)(this).parent().find('.product-detail__info-item-content').slideUp();
      (0, _jquery2.default)(this).parent().removeClass('is-open');
    } else {
      (0, _jquery2.default)(this).parent().find('.product-detail__info-item-content').slideDown();
      (0, _jquery2.default)(this).parent().addClass('is-open');
    }
  });

  (0, _jquery2.default)(".customerservice__item-top").click(function () {
    var Parent = (0, _jquery2.default)(this).parent();
    if (Parent.hasClass("open")) {
      (0, _jquery2.default)(this).parent().find('.customerservice__item-content').slideUp();
      (0, _jquery2.default)(this).parent().removeClass('open');
    } else {
      (0, _jquery2.default)(this).parent().find('.customerservice__item-content').slideDown();
      (0, _jquery2.default)(this).parent().addClass('open');
    }
  });

  (0, _jquery2.default)(".customerservice__menu-item-link").click(function () {});

  (0, _jquery2.default)('body').on('click', '.customerservice__menu-item-link', function () {
    var expand = (0, _jquery2.default)(this).attr('data-expand');
    (0, _jquery2.default)('section.faq-section').removeClass('is-active');
    (0, _jquery2.default)('section.faq-section[data-expand="' + expand + '"]').addClass('is-active');
    // $('.FaqSummary div, .faq-summary-mobile').removeClass('is-active');
    // $(this).closest('div').addClass('is-active');
  });

  // $('body').on('click', '.modal-info-button', function(e){
  //   e.preventDefault();
  //   var handle = $(this).data('handle');
  //   $.getJSON(handle, function(page) {
  //     var pageTitle = page.page.title;
  //     var pageContent = page.page.body_html;
  //     var modalTitle = document.querySelector('.info-modal .title');
  //     var modalContent = document.querySelector('.info-modal .content');
  //     modalTitle.innerHTML = pageTitle;
  //     modalContent.innerHTML = page.page.body_html;
  //     $('.info-modal').toggleClass('active');
  //   });
  // })
});

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)(window).on("resize", function (e) {
    checkScreenSize();
  });

  checkScreenSize();

  function checkScreenSize() {
    var newWindowWidth = (0, _jquery2.default)(window).width();
    if (newWindowWidth < 875) {
      (0, _jquery2.default)('.info-bar__inner').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      });

      (0, _jquery2.default)('.product-slider__inner').slick({
        dots: true,
        infinite: true,
        speed: 300,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: '<span class="product-slider__arrow product-slider__arrow--next"><svg width="11" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 19l9-9-9-9" stroke="#000"/></svg></span>',
        prevArrow: '<span class="product-slider__arrow product-slider__arrow--prev"><svg style="transform: rotate(180deg)" width="11" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 19l9-9-9-9" stroke="#000"/></svg></span>'
      });

      (0, _jquery2.default)('.usps-bar__items').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 750,
        fade: true,
        cssEase: 'linear'
      });

      (0, _jquery2.default)(".footer__menu-title").click(function () {
        var Parent = (0, _jquery2.default)(this).parent();
        if (Parent.hasClass("is-open")) {
          (0, _jquery2.default)(this).parent().find('.footer__menu-content').slideUp();
          (0, _jquery2.default)(this).parent().removeClass('is-open');
        } else {
          (0, _jquery2.default)(this).parent().find('.footer__menu-content').slideDown();
          (0, _jquery2.default)(this).parent().addClass('is-open');
        }
      });
    } else {
      if ((0, _jquery2.default)(".info-bar__inner").hasClass("slick-initialized")) {
        (0, _jquery2.default)('.info-bar__inner').slick('unslick');
      }
      if ((0, _jquery2.default)(".usps-bar__items").hasClass("slick-initialized")) {
        (0, _jquery2.default)('.usps-bar__items').slick('unslick');
      }
      if ((0, _jquery2.default)(".product-slider__inner").hasClass("slick-initialized")) {
        (0, _jquery2.default)('.product-slider__inner').slick('unslick');
      }
    }
  }
});